import React, { useEffect, useState } from "react";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import VouchernoSetting from "../Setting/VoucherNo";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import {
  partyDisplayName,
  payModeInputFlags,
  refresh_ParyAcc,
  setAcc_BanKName,
  setAcc_InpuPermission,
  setAcc_Party,
  setAcc_PartyBank,
  setAcc_VenType,
  setAcc_field,
} from "../features/Accounts";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";

function PayRecBody(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const _Selectparem = useSelector((state) => state.SelectOption.parems);
  const _AccParem = useSelector((state) => state.Accounts.default);
  const _HTParem = useSelector((state) => state.Accounts.HT);
  const _TabParem = useSelector((state) => state.Accounts.TabOrder);

  const [arrVendore, setarrVendore] = useState([]);
  const [arrAllBank, setarrAllBank] = useState([]);
  const [isVouchNoSett, setisVouchNoSett] = useState(false);

  useEffect(() => {
    View_AllVendores(_AccParem.iVenTypeId, "");
  }, [_AccParem.iVenTypeId]);

  useEffect(() => {
    SearchBank("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ViewAllBankUrl]);

  const sessionParams = async () => {
    const local = (await DecryptData(localStorage.jbctrlparams)) || {};
    return {
      Branch: Number(_AuthParems.Branch || local.Branch),
      DB: _AuthParems.DB || local.DB,
    };
  };

  const View_AllVendores = async (VenType, strtext) => {
    const session = await sessionParams();

    let strcolname = "";
    let ScrId = 0;
    switch (Number(VenType)) {
      case 4:
        ScrId = 2;
        strcolname = "CustName";
        break;
      case 5:
        ScrId = 50;
        strcolname = "VenName";
        break;
      case 6:
        ScrId = 100;
        strcolname = "CustName";
        break;
      default:
        ScrId = 3;
        strcolname = "SuppName";
        break;
    }
    const parems = {
      iScrId: ScrId,
      iPartyId: Number(VenType) || 0,
      strColName: strcolname,
      strSearch: strtext,
      strDBName: session.DB,
      iBranchId: session.Branch,
    };
    const res = await API_POST(`PartyTrans/Search_Party`, parems, dispatch);
    if (res) {
      setarrVendore(res.EntParty || []);
    }
  };
  const View_Party = async (iVenId) => {
    const session = await sessionParams();
    const res = await API_FETCH(
      `${props.PartyUrl}${_AccParem.iVenTypeId}/${iVenId}/${session.Branch}/${session.DB}`,
      dispatch
    );
    if (res) {
      const objParty = (res.objEntParty || [])[0];
      dispatch(
        setAcc_Party({
          strVenName: partyDisplayName(objParty),
          iVenId: Number(iVenId),
        })
      );
      if (Number(_AccParem.iPayModeId) > 1) {
        PayMode_OnChange(Number(_AccParem.iPayModeId), Number(iVenId));
      }
    }
  };
  const KeyDown = (e) => {
    var maxTab = Number(sessionStorage.maxTab);
    var ActiveIndex = document.activeElement.tabIndex;
    if (e.key === "Enter") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === _TabParem.PaymentListTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowDown") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === _TabParem.PaymentListTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowUp") {
      if (ActiveIndex > 0 && ActiveIndex <= maxTab) {
        if (ActiveIndex - 1 === _TabParem.PaymentListTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex - 1) + "']").select();
        }
      } else {
        if (maxTab - 1 === _TabParem.PaymentListTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (maxTab - 1) + "']").focus();
          $("[tabindex='" + (maxTab - 1) + "']").select();
        }
      }
    }
  };
  const Input_OnChange = (val, type) => {
    // FIX: this used to rebuild the WHOLE voucher object from a stale
    // render-time copy on every keystroke, which (a) undid the vendor reset
    // done just before it when Vendor Type changed, and (b) wrote the
    // selected Bank ACCOUNT id into iBankId (the vendor's bank) so the
    // account the user picked was never the one saved. Now: one field,
    // one reducer.
    if (type === "VenType") {
      dispatch(setAcc_VenType(Number(val)));
      return;
    }
    const fieldMap = {
      VouchNo: "strVouchNo",
      VouchDate: "strVouchDate",
      PrintName: "strPrintName",
      ChequeNo: "strChequeNo",
      ChequeDate: "strChequeDate",
      BankAccId: "iBankAccId",
      AccHName: "strAccHolderName",
      AccNo: "strAccNo",
      dAmount: "dAmount",
      Remark: "strRemark",
    };
    const key = fieldMap[type];
    if (!key) return;
    dispatch(
      setAcc_field({
        key,
        value: type === "BankAccId" ? Number(val) : val,
      })
    );
  };
  const SearchBank = async (strtext) => {
    if (!props.ViewAllBankUrl) return;
    const session = await sessionParams();
    const objSearch = {
      strSearch: strtext,
      strDBName: session.DB,
    };
    const res = await API_POST(`${props.ViewAllBankUrl}`, objSearch, dispatch);
    if (res) {
      setarrAllBank(res.EntBank || []);
    }
  };
  const PayMode_OnChange = async (value, venIdOverride) => {
    const iMode = Number(value);
    const iVenId = Number(
      venIdOverride !== undefined ? venIdOverride : _AccParem.iVenId
    );
    const flags = payModeInputFlags(iMode);
    dispatch(setAcc_field({ key: "iPayModeId", value: iMode }));
    dispatch(setAcc_InpuPermission(flags));
    if (iMode === 1) {
      dispatch(refresh_ParyAcc());
      return;
    }
    if (iMode !== 2) {
      dispatch(setAcc_field({ key: "strChequeNo", value: "" }));
    }
    if (iVenId > 0 && Number(_AccParem.iVenTypeId) > 0) {
      const session = await sessionParams();
      const res = await API_FETCH(
        `${props.ViewPartyBankUrl}${iVenId}/${_AccParem.iVenTypeId}/${session.DB}`,
        dispatch
      );
      if (res) {
        const arrBank = res.objPartyBank || [];
        if (arrBank.length > 0) {
          let objBank = arrBank[0];
          dispatch(
            setAcc_PartyBank({
              iPayModeId: iMode,
              strChequeNo: "",
              strAccHolderName: objBank.strAccHolderName,
              iBankId: objBank.iBankNameId,
              strBankName: objBank.strBankName,
              strAccNo: objBank.strAccNo,
            })
          );
        } else {
          dispatch(
            setAcc_PartyBank({
              iPayModeId: iMode,
              strChequeNo: "",
              strAccHolderName: "",
              iBankId: 0,
              strBankName: "",
              strAccNo: "",
            })
          );
        }
      }
    }
  };
  const fmt = (_HTParem.arrNoFormat || [])[0];
  const isManualNo = !!(fmt && (fmt.isManualNumber || fmt.isManualNo));
  const bankOptions = (() => {
    const list = arrAllBank || [];
    if (
      Number(_AccParem.iBankId) > 0 &&
      _AccParem.strBankName &&
      !list.some(
        (b) => String(b.bnId) === String(_AccParem.iBankId)
      )
    ) {
      return [
        { bnId: _AccParem.iBankId, bankNames: _AccParem.strBankName },
        ...list,
      ];
    }
    return list;
  })();
  return (
    <div className="row p-2">
      <div className="col-md-3 col-sm-6 mt-1">
        <label>
          Voucher no <span className="danger">*</span>
        </label>
        <div>
          <input
            type="text"
            className="form-control"
            placeholder="Voucher Number"
            value={_AccParem.strVouchNo}
            tabIndex={_TabParem.VoucherTab}
            onKeyDown={(e) => KeyDown(e)}
            readOnly={!isManualNo}
            onChange={(e) => Input_OnChange(e.target.value, "VouchNo")}
          />
          <span
            className="inv-no"
            onClick={() => setisVouchNoSett(!isVouchNoSett)}
          >
            <i className="bx bx-cog"></i>
          </span>
          {isVouchNoSett && (
            <VouchernoSetting
              iScrId={props.iScrId}
              Close={() => setisVouchNoSett(false)}
              onSaved={props.RefreshNoFormat}
            />
          )}
        </div>
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>
          Date <span className="danger">*</span>
        </label>
        <input
          type="date"
          name="strVouchDate"
          className="form-control"
          tabIndex={_TabParem.VouchDateTap}
          onKeyDown={(e) => KeyDown(e)}
          value={_AccParem.strVouchDate}
          onChange={(e) => Input_OnChange(e.target.value, "VouchDate")}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>
          Trans No <span className="danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          tabIndex={_TabParem.TransNoTab}
          onKeyDown={(e) => KeyDown(e)}
          value={_AccParem.strTransNo}
          readOnly
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>
          Vendor Type <span className="danger">*</span>
        </label>
        <CustomizedSelectoption
          optionparem="isoptionShow"
          showoption={_Selectparem.isoptionShow}
          placeholder="Select Vendore Type"
          taborder={_TabParem.VenTypeTab}
          keydown={(e) => KeyDown(e)}
          select_value={(val) => {
            // vendor list reloads via the useEffect on iVenTypeId
            if (Number(val) !== Number(_AccParem.iVenTypeId)) {
              Input_OnChange(val, "VenType");
            }
          }}
          btnname="Location"
          btnshow={false}
          show_popup=""
          valueonly={true}
          defaultval={Number(_AccParem.iVenTypeId)}
          displayName="strVenTypeName"
          disvalue="iVenTypeId"
          arrydata={_HTParem.arrVenType}
          EmptVal="Vendor Type "
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>
          Vendor Name <span className="danger">*</span>
        </label>
        <CustomizedSelectoption
          optionparem="isoptionShow1"
          showoption={_Selectparem.isoptionShow1}
          placeholder="Select Vendore"
          taborder={_TabParem.VenNameTab}
          keydown={(e) => KeyDown(e)}
          onChange={(val) => View_AllVendores(_AccParem.iVenTypeId, val)}
          select_value={(val) => View_Party(val)}
          btnname="Vendor"
          btnshow={false}
          show_popup=""
          valueonly={true}
          defaultval={Number(_AccParem.iVenId)}
          displayName="partyName"
          disvalue="partyId"
          disabled={Number(_AccParem.iVenTypeId) === 6 ? true : false}
          arrydata={arrVendore}
          EmptVal="Vendor "
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Print Name</label>
        <input
          type="text"
          aria-label="First name"
          className="form-control"
          onKeyDown={(e) => KeyDown(e)}
          name="strPrintName"
          placeholder="Enter Print Name"
          tabIndex={_TabParem.PrintNameTab}
          value={_AccParem.strPrintName}
          onChange={(e) => Input_OnChange(e.target.value, "PrintName")}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Payment Mode</label>
        <CustomizedSelectoption
          optionparem="isoptionShow2"
          showoption={_Selectparem.isoptionShow2}
          placeholder="Select Payment Mode"
          taborder={_TabParem.PayModeTab}
          keydown={(e) => KeyDown(e)}
          select_value={(val) => PayMode_OnChange(val)}
          btnname="Payment Mode"
          btnshow={false}
          show_popup=""
          valueonly={true}
          defaultval={Number(_AccParem.iPayModeId)}
          displayName="strPaymentMode"
          disvalue="iPM_Id"
          arrydata={_HTParem.arrPayMode}
          EmptVal="Payment Mode"
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Bank Account</label>
        <CustomizedSelectoption
          optionparem="isoptionShow3"
          showoption={_Selectparem.isoptionShow3}
          placeholder="Select Bank Account"
          taborder={_TabParem.BankAccountTab}
          keydown={(e) => KeyDown(e)}
          select_value={(val) => {
            if (!_AccParem.isBanAcc) {
              Input_OnChange(val, "BankAccId");
            }
          }}
          btnname="Payment Mode"
          btnshow={false}
          show_popup=""
          valueonly={true}
          defaultval={Number(_AccParem.iBankAccId)}
          displayName="bankNames"
          disvalue="bankAccId"
          disabled={_AccParem.isBanAcc ? true : false}
          arrydata={_HTParem.arrBankAcc}
          EmptVal="Bank Account"
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Cheque Number </label>
        <input
          type="text"
          aria-label="First name"
          className="form-control"
          name="strChequeNo"
          tabIndex={_TabParem.CheckNoTab}
          placeholder="Enter Cheque Number"
          readOnly={_AccParem.isCheque}
          value={_AccParem.strChequeNo}
          onKeyDown={(e) => KeyDown(e)}
          onChange={(e) => Input_OnChange(e.target.value, "ChequeNo")}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Cheque Date</label>
        <input
          type="date"
          className="form-control"
          name="strChequeDate"
          value={_AccParem.strChequeDate}
          readOnly={_AccParem.isCheque}
          tabIndex={_TabParem.CheckDateTab}
          onKeyDown={(e) => KeyDown(e)}
          onChange={(e) => Input_OnChange(e.target.value, "ChequeDate")}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Bank Name </label>
        <CustomizedSelectoption
          optionparem="isoptionShow4"
          showoption={_Selectparem.isoptionShow4}
          placeholder="Select Bank "
          taborder={_TabParem.BankNameTab}
          keydown={(e) => KeyDown(e)}
          onChange={(val) => SearchBank(val)}
          select_value={(val) => {
            dispatch(
              setAcc_BanKName({
                iBankId: val.bnId,
                strBankName: val.bankNames,
              })
            );
          }}
          btnname="Bank"
          btnshow={false}
          show_popup=""
          valueonly={false}
          defaultval={Number(_AccParem.iBankId)}
          displayName="bankNames"
          disvalue="bnId"
          disabled={_AccParem.isBanAcc}
          arrydata={bankOptions}
          EmptVal="Bank"
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Account Holder Name</label>
        <input
          type="text"
          aria-label="First name"
          className="form-control"
          name="strAccHolderName"
          placeholder="Enter Account Holder Name"
          tabIndex={_TabParem.AccHolTab}
          onKeyDown={(e) => KeyDown(e)}
          value={_AccParem.strAccHolderName}
          onChange={(e) => Input_OnChange(e.target.value, "AccHName")}
          readOnly={_AccParem.isBanAcc}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Account Number</label>
        <input
          type="text"
          aria-label="First name"
          className="form-control"
          tabIndex={_TabParem.AccNoTab}
          onKeyDown={(e) => KeyDown(e)}
          name="strAccNo"
          placeholder="Enter Account Number"
          value={_AccParem.strAccNo}
          onChange={(e) => Input_OnChange(e.target.value, "AccNo")}
          readOnly={_AccParem.isBanAcc}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Amount</label>
        <input
          type="number"
          aria-label="First name"
          className="form-control"
          onKeyDown={(e) => KeyDown(e)}
          onClick={(e) => e.target.select()}
          tabIndex={_TabParem.AmountTab}
          name="dAmount"
          style={{ textAlign: "left" }}
          value={_AccParem.dAmount}
          onChange={(e) => Input_OnChange(e.target.value, "dAmount")}
        />
      </div>
      <div className="col-md-3 col-sm-6 mt-1">
        <label>Remarks </label>
        <input
          type="text"
          aria-label="First name"
          className="form-control"
          onKeyDown={(e) => KeyDown(e)}
          name="strRemark"
          tabIndex={_TabParem.Remarktab}
          placeholder="Enter Remarks"
          value={_AccParem.strRemark}
          onChange={(e) => Input_OnChange(e.target.value, "Remark")}
        />
      </div>
    </div>
  );
}

export default PayRecBody;